import React, { useState } from "react";
import { Form, Button, Row, Col, Alert, Container } from "react-bootstrap";
import axios from "axios";
import { MyApi } from "../MyApi";

export default function EnquiryForm() {

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: ""
  });

  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);
      setSuccessMsg("");
      setErrorMsg("");

      const res = await axios.post(
        MyApi.BASE_URL + MyApi.ENQUIRY_FORM,
        formData,
        {
          headers: { Authorization: MyApi.SECRET_KEY },
        }
      );

      if (res.data.status === true) {
        setSuccessMsg("Your enquiry has been submitted successfully.");
        setFormData({
          name: "",
          mobile: "",
          email: "",
          subject: "",
          message: ""
        });
      } else {
        setErrorMsg(res.data.message || "Something went wrong");
      }

    } catch (err) {
      console.error(err);
      setErrorMsg("Server error. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="py-4">
      <h3 className="mb-4">Send Us an Enquiry</h3>

      {successMsg && <Alert variant="success">{successMsg}</Alert>}
      {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Button type="submit" disabled={submitting}>
          {submitting ? "Submitting..." : "Submit Enquiry"}
        </Button>
      </Form>
    </Container>
  );
}